/** Relative label for “Catalog updated: …” */
export function formatCatalogUpdatedLabel(updatedAtMs: number, nowMs = Date.now()): string {
  const sec = Math.floor((nowMs - updatedAtMs) / 1000)
  if (sec < 10) return 'Just now'
  if (sec < 60) return `${sec}s ago`
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min} min ago`
  const h = Math.floor(min / 60)
  if (h < 48) return `${h} h ago`
  const d = Math.floor(h / 24)
  return `${d} d ago`
}
